<template>
    <div class="header-button button-personal" @click="openCabinet()">
        <span class="balloon bonus-balance" v-if="isAuthorize">{{ bonuses }}</span>
        <span class="pp-icon pp-icon-personal"></span>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import Utils from "../Utils";
    export default {
        name: "ButtonPersonal",
        computed: {
            ...mapGetters('user', {
                isAuthorize: 'isAuthorize',
                bonuses: 'getBonuses',
            }),
        },
        methods: {
            openCabinet: function () {
                this.$store.commit('app/setShowingCabinet');
                this.addFixedBodyClass(true);
            }
        },
        mixins: [Utils],
    }
</script>

<style scoped>

</style>
